export enum CheckpointOperationType {
    LOAD = 'load',
    UNLOAD = 'unload',
    RETURN = 'return',
    STOPOVER = 'stopover',
    NON_SPECIFIED = 'non_specified',
}
